import smartSolveApi from './instances/smartsolve';

export async function uploadScormContent(data) {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });

  return await smartSolveApi.post('/CreateScormPackage', formData);
}

export async function createScormUserRegistration(data) {
  return await smartSolveApi.post('/CreateScormUserRegistration', data);
}

export async function launchPreview(data) {
  return await smartSolveApi.post('/LaunchPreview', data);
}
